import { render, staticRenderFns } from "./SignTemplate.vue?vue&type=template&id=b1b7254a&"
import script from "./SignTemplate.vue?vue&type=script&lang=js&"
export * from "./SignTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SignTemplate.vue?vue&type=style&index=0&id=b1b7254a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports